import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import moment from 'moment-timezone';
import 'moment/locale/id';
import 'moment/locale/ms';
import 'moment/locale/th';
import 'moment/locale/vi';
import 'moment/locale/zh-cn';

const isDebugEnabled = !!(typeof window !== 'undefined' && window.MILO_CONFIG && window.MILO_CONFIG.ENABLE_DEBUG);
const normalizeLanguageCode = (language) => String(language || 'en').toLowerCase().replace('_', '-').split('-')[0];

const momentLocaleMap = {
  en: 'en',
  vi: 'vi',
  zh: 'zh-cn',
  th: 'th',
  id: 'id',
  ms: 'ms',
};

const getMomentLocale = (language) => momentLocaleMap[normalizeLanguageCode(language)] || momentLocaleMap.en;

const getCurrentLanguage = () => {
  if (i18n.resolvedLanguage) return i18n.resolvedLanguage;
  if (i18n.language) return i18n.language;
  if (typeof window !== 'undefined') {
    return (
      sessionStorage.getItem('language')
      || localStorage.getItem('i18nextLng')
      || 'en'
    );
  }
  return 'en';
};

const syncMomentLocale = (language) => {
  moment.locale(getMomentLocale(language));
};

i18n
  .use(XHR)
  .use(LanguageDetector)
  .init({
    debug: isDebugEnabled,
    ns: ['auth', 'common', 'validation', 'reports', 'pdf', 'onboarding'],
    defaultNS: 'common',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // react already escapes value
    },
    backend: {
      loadPath: '{{lng}}/{{lng}}.{{ns}}.json',
      ajax: (url, options, callback, data) =>
        import(/* webpackChunkName: '[request]' */ `dataModule/assets/i18n/locales/${url}`)
          .then(({ default: locale }) => callback(JSON.stringify(locale), { status: '200' }))
          .catch((error) => {
            console.warn(
              `%cUnable to import locale ${url}`,
              'font-size: 12px; color: lightcoral',
              error,
            );
            callback(null, { status: '404' });
          }),
    },
    detection: {
      lookupQuerystring: 'language', // default is lng
      // order and from where user language should be detected
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'],
    },
  });

i18n.on('initialized', () => syncMomentLocale(getCurrentLanguage()));
i18n.on('languageChanged', (language) => syncMomentLocale(language));

export default i18n;
